'use client';

import { useMemo } from 'react';
import { getCookie } from 'cookies-next';

export function useReplaceClickId(inputString: string) {
  const replacedString = useMemo(() => {
    if (typeof window === 'undefined') return inputString;

    const clickId = getCookie('adwords') || 'kobiorganic';

    return inputString
      .replaceAll('{click_id}', String(clickId))
      .replaceAll('%7Bclick_id%7D', encodeURIComponent(String(clickId)));
  }, [inputString]);

  return replacedString;
}
